export const countCodePoints = (value) => {
  if (value === null || value === undefined) return 0

  return Array.from(String(value)).length
}

export const truncateCodePoints = (value, max) => {
  if (value === null || value === undefined) return value

  const chars = Array.from(String(value))

  return chars.length <= max ? String(value) : chars.slice(0, max).join('')
}
